import React from "react";
import Logo from "@/assets/logo.png";

export const AppIcon: React.FC = () => {
  return <img src={Logo} width={24} height={24} />;
};
